import { inferenceHttp } from '@/lib/api/inference-client';
import { logger } from '@/lib/utils/logger';

export interface SubmitNACBIntakeDto {
  name: string;
  brand: string;
  businessSituation: string;
  turnaroundTimeframe: string;
  involvementLevel: string;
}

export interface NACBIntakeResponseDto {
  id: string;
  submittedAt: string;
  status: 'success' | 'pending' | 'error';
  message: string;
}

/**
 * Submit NACB Trigger Intake Form
 */
export const submitNACBIntake = async (
  body: SubmitNACBIntakeDto,
): Promise<NACBIntakeResponseDto> => {
  try {
    const response = await inferenceHttp.post({
      url: '/api/v1/nacb-intake/submit',
      body,
    });
    return response.data as NACBIntakeResponseDto;
  } catch (error) {
    logger.error('Failed to submit NACB intake form:', error);
    throw error;
  }
};
